import { render, staticRenderFns } from "./WaveTextBlock.vue?vue&type=template&id=3426cd02"
import script from "./WaveTextBlock.vue?vue&type=script&lang=js"
export * from "./WaveTextBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports